import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Modal} from "react-bootstrap";

class ContactMeConfirmationModal extends Component {
    static propTypes = {
        show: PropTypes.bool.isRequired,
        onHide: PropTypes.func.isRequired
    };
    static defaultProps = {};
    state = {};

    render() {
        return (
            <Modal {...this.props} className="modal-alert modal-success" bsSize="small">
                <Modal.Header>
                    <img style={{width: '110x', height: '110px', borderRadius: '55px', borderOolor: 'green', borderWidth: '2px'}}
                         src="/img/email/tanya.png"/>
                </Modal.Header>
                <Modal.Body>
                    <h5>Спасибо!</h5>
                    <p>
                        Мы приняли Вашу заявку и в ближайшее время с Вами свяжется специалист NetPallet для того,{' '}
                        чтобы обсудить детали.
                    </p>
                    <p>
                        Не хотите ждать? Вы всегда можете связаться с нами:
                    </p>
                    <div className="row">
                        <div className="col-md-6 text-right p-r-0">
                            Горячая линия
                        </div>
                        <div className="col-md-6 text-left">
                            <a href="tel:84996475062">8 (499) 647-50-62</a>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6 text-right p-r-0">
                            Служба поддержки
                        </div>
                        <div className="col-md-6 text-left">
                            <a href="mailto:info@netpal.ru">info@netpal.ru</a>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-success"
                            onClick={() => this.redirect()}>
                        ОК
                    </button>
                </Modal.Footer>
            </Modal>
        );
    }

    redirect() {
        let host = window.location.host;
        if (host.indexOf('localhost') !== -1) {
            window.location = 'http://localhost:3000';
        }
        else if (host.indexOf('artlogics') !== -1) {
            window.location = 'https://landing.netpallet.artlogics.ru';
        }
        else {
            window.location = 'https://netpallet.ru';
        }
    }
}

export default ContactMeConfirmationModal;


// WEBPACK FOOTER //
// ./src/pages/Adverts/CreateAdvert/modals/ContactMeConfirmationModal.js